import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { FeatItems, MenuItems } from "./MenuItems";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";

export function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("instances");

  useEffect(() => {
    const currentPath = location.pathname;

    const matchedItem = [...FeatItems, ...MenuItems].find(
      (item) =>
        item.href === currentPath ||
        (item.href !== "/" && currentPath.startsWith(item.href)),
    );

    if (matchedItem) {
      setActiveTab(matchedItem.value);
    } else {
      setActiveTab("instances");
    }
  }, [location.pathname]);

  return (
    <div className="flex flex-shrink-0 border-b min-w-[1400px]">
      <Tabs
        value={activeTab}
        className="min-w-[1400px] max-w-[1600px] w-full mx-auto "
      >
        <TabsList>
          {FeatItems.map((item) => (
            <TabsTrigger
              key={item.value}
              value={item.value}
              onClick={() => navigate(item.href)}
              className=""
            >
              <view className="inline-flex items-center justify-center px-3 py-2 gap-x-2">
                <item.icon className="w-5 h-5" />
                <view className="body-14Bold">{item.label}</view>
              </view>
            </TabsTrigger>
          ))}

          <view className="w-0 h-4 border m-4" />

          {MenuItems.map((item) => (
            <TabsTrigger
              key={item.value}
              value={item.value}
              onClick={() => navigate(item.href)}
              className=""
            >
              <view className="inline-flex items-center justify-center px-3 py-2 gap-x-2">
                <item.icon className="w-5 h-5" />
                <view className="body-14Bold">{item.label}</view>
              </view>
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
